//PARENT COMPOMENT (CONTAINER) WHICH HOLD ALL COMPONENTS RELATED TO CHOOSING THE BOOKS 
import React, { Component } from 'react';
import { Redirect } from 'react-router';
import '../styles/BookPicker.css';
import Search from './Search';
import BookList from './BookList';
import PickedBookList from './PickedBookList';
import Instructions from './Instructions';
import background from '../images/fantasy-3077928_1920_opt.jpg';

class BookPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResult: {items: []},
      selectedBooks: [], //Array of objects, where is object is a book
      searchValue: '',
      spinner: false,
      redirect: false,
    }
  }

  searchBook = () => {
    this.setState({searchResult: {items: []}, spinner: true})
    let searchValueNoSpaces = this.state.searchValue.replace(/\s+/g, '+');
    fetch('https://www.googleapis.com/books/v1/volumes?q=' + searchValueNoSpaces + '+subject:fiction&langRestrict=en')
    .then(response => response.json())
    .then(json => {
      this.setState({searchResult: json, spinner: false})
    })
  }

  updateSearchValue = (value) => {
    this.setState({searchValue: value});
  }

  selectBook = (book) => {
    //If empty add to selected books
    let selectedBooks = [];
    if (this.state.selectedBooks.length === 0) {
      selectedBooks.push(book);
      this.setState({
        selectedBooks: selectedBooks,
        searchValue: '',
        searchResult: {items: []},
      });
    }

    //Only add if the book is not already added and list length < 6
    if (this.state.selectedBooks.length < 5) {
      for (let i = 0; i < this.state.selectedBooks.length; i++){
        if (this.state.selectedBooks[i].id === book.id) break;
        selectedBooks.push(this.state.selectedBooks[i])
        if (i === this.state.selectedBooks.length-1) {
          selectedBooks.push(book);
          this.setState({
            selectedBooks: selectedBooks,
            searchValue: '',
            searchResult: {items: []},
          });
        }
      }
    }
  }

  removePickedBook = (bookToRemove) => {
    let newArr = [];
    for (let i = 0; i < this.state.selectedBooks.length; i++) {
      if (this.state.selectedBooks[i].id !== bookToRemove.id) newArr.push(this.state.selectedBooks[i])
    }
    this.setState({
      selectedBooks: newArr,
      clicked: false
    })
  }

  getRecommendations = () => {
    if (this.state.selectedBooks.length !== 5 && !this.state.selectedBooks.clicked) return null;
    this.setState({clicked: true, spinner: true});
    fetch('http://ec2-18-221-182-179.us-east-2.compute.amazonaws.com:8080/Rating', {
      // fetch('http://localhost:8080/Rating', {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify({books: this.state.selectedBooks, user: this.props.user})
    })
    .then(response => response.json())
    .then(json => {
      this.props.getResults(json);
      this.setState({redirect: true})

    })
    .catch(err => console.log(err.message));
  }

  renderButtonClass = () => {
    if (this.state.selectedBooks.length === 5) return 'BookPickerButton Flash';
    else return 'BookPickerButton'

  }

  renderFirstRow = () => {
    if (this.state.selectedBooks.length === 0 && this.state.searchValue === '') return <Instructions />
    else return <PickedBookList removePickedBook={this.removePickedBook} selectedBooks={this.state.selectedBooks}/>
    
  }

  renderIfBooks = () => {
    if (this.state.selectedBooks.length !== 0 || this.state.searchValue !== '') return <p className='YourPicks'>Your awesome book picks... {(this.state.selectedBooks.length)+'/5'}</p>
  }

  renderBookList = () => {
    if (this.state.searchValue.replace(/\s/g, "").length > 0) return <BookList books={this.state.searchResult.items} selectBook={this.selectBook} />
  }

  renderButton = () => {
    if (this.state.selectedBooks.length === 5 && !this.state.clicked) return <input className={this.renderButtonClass()} type='button' value='Submit' onClick={this.getRecommendations}/>
  }

  renderSpinner = () => {
    if (this.state.spinner) return  <div className="loader">Loading...</div>;
  }


  render() {
    document.body.style.backgroundImage = `url(${background})`;
    if (this.state.redirect) return <Redirect to='/results'/>;
    else
    return (
      <div className='BookPicker'>

        <div className='firstRowBookPicker'>

          <div className='secondRowBookPickerComponents'>
            <Search searchBook={this.searchBook} updateSearchValue={this.updateSearchValue} searchValue={this.state.searchValue}/>  
          </div>
          
          {this.renderIfBooks()}
          {this.renderFirstRow()}
        </div>
        
        <div className='secondRowBookPicker'>
          {this.renderBookList()}
          {this.renderButton()}
          {this.renderSpinner()}
        </div>

        
      </div>
    )
  }
}

export default BookPicker;


// WEBPACK FOOTER //
// ./src/components/BookPicker.js